import angular from 'angular';
import template from './postal-address.html';

const postalAddressConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('postaladdress', {
		title:    'Postal Address',
		group:    'advanced',
		/**
		 * @param {any} data
		 * @returns {string}
		 */
		tableView(data) {
			return data ? data.name : '';
		},
		template,
		views:    [
			{
				name:     'Display',
				template: 'kform/components/postal-address/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/postal-address/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		children:   false,
		selectable: true,
		settings: {
			disabled:    false,
			input:       true,
			persistent:  false,
			tableView:   true,
			label:       'Postal Address',
			key:         'postalAddressField',
			hideLabel:   false,
			theme:       'default',
			size:        'md',
			protected:   true,
			autofocus:   false,
			hidden:      false,
			clearOnHide: true,
			spellcheck:  true,
			validate:    {
				card: '0-1',
				custom:        '',
			},
			kdata:       {
				submit: true,
			},
		},
		icon:     'fa fa-map-marker',
	});
};

export default angular.module('app').config(postalAddressConfig);
